module.exports = __webpack_public_path__ + "img/cave119.99d650ed.jpg";